import { render } from "./Success.vue?vue&type=template&id=71f5de80"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=71f5de80&lang=css"
script.render = render

export default script